import { CnLoading } from '@alife/cn-ui';
export function Loading(props) {
    return (<CnLoading style={{ width: '100%' }} visible={!!props?.visible} tip={'loading...'}>
      {props.children}
    </CnLoading>);
}
